<!-- 해당 파일 수정시, PartnerLectureDetailView 파일도 함께 검토 후 수정 -->
<script setup>
    import axios from 'axios'
    import { ref, onMounted, getCurrentInstance } from 'vue'
    import { useRoute, useRouter } from 'vue-router'
    import { storeToRefs } from "pinia";
    import { usePageLoadingStore } from "../../../../stores/pageLoading";
    import { useUserStore } from "../../../user/stores/user";
    import lectureService from "../../services/lecture/lectureService";
    import certificateTemplateService from '../../services/lecture/certificateTemplateService';
    import SNBAdmin from '../../../../layouts/nav/SNBAdmin.vue'
    import SNBPartAdmin from "../../../../layouts/nav/SNBPartAdmin.vue";
    import { useAlertStore } from "../../../../stores/alertStore";
    import _ from "lodash";

    const { $alert, $confirm } = useAlertStore();
    const route = useRoute()
    const router = useRouter()
    const loadingStore = usePageLoadingStore()
    const userStore = useUserStore()
    const { isPartAdmin } = storeToRefs(userStore);
    const { $toast, $pageListBoardNo, $gb : { USER_GB } } = getCurrentInstance().appContext.config.globalProperties;

    const currentURL = window.location.host;

    onMounted(()=>{
        const { id } = route.params;
        if(!id) {
            router.push({name:'LectureCertificateTemplateManage'});
        } else {
            detail.value = {
                ...detail.value,
                templateId: id,
            }
            retrieveDetail(id);
            retrieveLectureList(id);
        }
    });

    const detail = ref({});
    const lectureList = ref([]);

    const tabIndex = ref(0);
    const currentPage = ref(1);
    const pageSize = ref(10);
    const totalPages = ref(0);
    const totalCount = ref(0);

    const pageSizeGroup = ref([
        { label:"10개씩 보기", value: "10" },
        { label:"30개씩 보기", value: "30" },
        { label:"50개씩 보기", value: "50" },
        { label:"100개씩 보기", value: "100" },
    ]);

    const retrieveDetail = (id) => {
        loadingStore.loading = true;
        certificateTemplateService.retrieveCertificateTemplateDetail(id)
            .then( (res) => {
                loadingStore.loading = false;
                // console.log(res);
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    detail.value = result;
                }
            }).catch( async (err) =>  {
                loadingStore.loading = false;
                console.log(err);
            });
    };

    const retrieveLectureList = (id) => {
        loadingStore.loading = true;
        const paramObj = {
            templateId: id || detail.value.templateId,
            pageNo: currentPage.value,
            size: pageSize.value,
        };
        certificateTemplateService.retrieveLectureList(paramObj)
            .then( (res) => {
                loadingStore.loading = false;
                // console.log(res);
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    totalPages.value = result.totalPages;
                    totalCount.value = result.totalElements;
                    lectureList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
                }
            }).catch( async (err) =>  {
                loadingStore.loading = false;
                console.log(err);
            });
    };

    const onSelectPage = (pageNo) => {
        currentPage.value = pageNo;
        retrieveLectureList();
    };

    const onSelectPageSize = (option) => {
        pageSize.value = option.value;
        currentPage.value = 1;
        retrieveLectureList();
    };

    const onSelectTab = (option) => {
        tabIndex.value = option.value;
        currentPage.value = 1;
        retrieveLectureList();
    };

    const handleClickDelete = async () => {
        const ok = await $confirm(["수료증 양식을 삭제할까요?", "수료증 양식 삭제시 연결된 강의 정보가 삭제되며 되돌릴 수 없습니다."], "삭제");
        if(ok) {
            loadingStore.loading = true;
            certificateTemplateService.deleteTemplate(detail.value.templateId)
                .then( async (res) => {
                    loadingStore.loading = false;
                    if(res.data.code.toLowerCase() === 'success') {
                        await $alert("삭제되었습니다.");
                        goBack();
                    }
                }).catch( (res) =>  {
                    // console.log(res);
                    loadingStore.loading = false;
                    $toast('error', '오류가 발생하였습니다.');
                });
        }
    };

    const handleClickEdit = () => {
        router.push({name:'LectureCertificateTemplateUpdate', params:{id: detail.value.templateId}})
    };

    const goBack = () => {
        router.push({name:'LectureCertificateTemplateManage'})
    };

    const onClickLectName = (lect) => {
        window.open(`/admin/lecture/manage/detail/${lect.lectId}`, '_blank');
    };
    
    const onClickLectCourseManage = (lect) => {
        window.open(`/admin/course/${lect.lectId}`, '_blank');
    };
</script>

<template>
    <div class="content">
        <div class="sub-title">
            <h3>수료증 양식 상세</h3>
        </div>
        <div class="btn-wrap space-between mb-xs">
            <KSASecondaryButton class="gray_button" text="목록" @click="goBack" />
            <div>
                <KSASecondaryButton class="gray_button" text="수정" @click="handleClickEdit" :disabled="lectureList.length > 0" />
                <KSASecondaryButton class="red_button" text="삭제" @click="handleClickDelete" :disabled="lectureList.length > 0" />
            </div>
        </div>
        <KSATab style="grid-template-columns: repeat(2, 1fr);" class="mb-lg"
                :options="[
                    {label:'양식 정보', value:0},
                    {label:`연결중 강의(${detail.linkedLectureCount || 0})`, value:1},
                ]"
                @change="onSelectTab"
        />
        <!-- s: 양식 정보 -->
        <div v-show="tabIndex === 0">
            <div class="table-form">
                <table class="vertical">
                    <colgroup>
                        <col width="10%" />
                        <col />
                        <col width="10%" />
                        <col />
                    </colgroup>
                    <tr>
                        <th>수료증명</th>
                        <td colspan="3">
                            {{ detail.certificateName }}
                        </td>
                    </tr>
                    <tr>
                        <th>등록일</th>
                        <td colspan="3">
                            {{ $yyyymmddHHmmss(detail.createDate) }}
                        </td>
                    </tr>
                </table>
                <div class="image-wrap">
                    <div class="image-box">
                        <div class="image-preview">
                            <KSAImage :src="detail.frontImageDir" />
                            <p>{{ detail.frontFixedText }}</p>
                        </div>
                        <div class="image-title">앞면 이미지</div>
                    </div>
                    <div class="image-box">
                        <div class="image-preview">
                            <KSAImage :src="detail.backImageDir" />
                        </div>
                        <div class="image-title">뒷면 이미지</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- e: 양식 정보 -->
        <!-- s: 연결된 강의 -->
        <div v-show="tabIndex === 1">
            <div class="list-top">
                <p>총 게시물 <span>{{ $number(totalCount) }}</span>개 (연결중 강의 {{ $number(detail.linkedLectureCount) || 0 }}개)</p>
                <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
            </div>
            <div class="table-form">
                <table class="horizontal">
                    <tr>
                        <th width="5%">강의ID</th>
                        <th width="5%">구분</th>
                        <th>강의명</th>
                        <th width="15%">교육기간</th>
                        <th width="5%">수강생수</th>
                        <th width="5%">수료자수</th>
                        <th width="22%">연결기간</th>
                        <th width="5%">수강 관리</th>
                    </tr>
                    <tr v-for="(lect, idx) in lectureList">
                        <td>{{ lect.lectId }}</td>
                        <td>{{ lect.lectGb === "01" ? "온라인" : "오프라인" }}</td>
                        <td class="text-left">
                            <KSATextButton :text="lect.lectName" @click="onClickLectName(lect)" />
                        </td>
                        <td>
                            {{ $yyyymmdd(lect.lectStartYmd) }}&nbsp; ~ &nbsp;{{ $yyyymmdd(lect.lectEndYmd) }}
                        </td>
                        <td>{{ $number(lect.userLectureStudyCount || 0) }}</td>
                        <td>{{ $number(lect.userLecturePassCount || 0) }}</td>
                        <td>
                            <div style="display:flex; align-items:center; justify-content: space-between;">
                                <span style="display:inline-block; width:100px;">{{ $yyyymmddHHmmss(lect.linkStartDate) }}</span>
                                <span>~</span>
                                <span style="display:inline-block; width:100px;">{{ lect.linkEndDate ? $yyyymmddHHmmss(lect.linkEndDate) : '연결중' }}</span>
                            </div>
                        </td>
                        <td>
                            <KSATextButton text="수강 관리" @click="onClickLectCourseManage(lect)" />
                        </td>
                    </tr>
                    <tr v-if="lectureList.length === 0">
                        <td colspan="8">연결된 강의가 없습니다.</td>
                    </tr>
                </table>
            </div>
            <Paginate
                v-if="lectureList.length > 0"
                v-model="currentPage"
                :page-count="totalPages"
                :click-handler="onSelectPage"
            />
        </div>
        <!-- e: 연결된 강의 -->
    </div>
</template>

<style lang="scss" scoped>
    @import "../../../../assets/scss/theme";

    .textarea-box {
        height: 100px;
    }

    .board-detail {
        .body {
            .text {
                overflow: hidden;
            }
        }
    }

    .image-wrap {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 1.5rem;
        margin-top: 15px;
    }

    .image-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 1rem;
        border: 1px solid #e5e5e5;
        padding: 15px;
        border-radius: 5px;
        .image-preview {
            position: relative;
            &:after {
                content: "";
                position: absolute;
                top: 0;
                left: 50%;
                display: block;
                width: 100%;
                height: 100%;
                background-repeat: no-repeat;
                background-position: center center;
                background-size: contain;
                z-index: 1;
                transform: translateX(-50%);
            }
        }
        &:first-child {
            .image-preview {
                &:after {
                    background-image: url("/src/assets/images/certificates_front_text.svg");
                }
            }
        }
        &:last-child {
            .image-preview {
                &:after {
                    background-image: url("/src/assets/images/certificates_back_text.svg");
                }
            }
        }
    }

    .image-preview {
        position: relative;
        width: 100%;
        height: 405px;
        background-color: #f5f5f5;
        border-bottom: 1px solid #e5e5e5;
        img {
            object-fit: contain;
        }
        p {
            position: absolute;
            width: 380px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -10%);
            font-size: 11px;
            text-align: center;
            word-break: break-word;
        }
    }

    .image-title {
        font-size: 14px;
        font-weight: 500;
        color: #333;
    }
</style>